export default "__VITE_ASSET__BJCWAWnH__"